import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class CustomIconsService {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {}

  // Registra l'icona 'more-vert-notify' (viewBox 24x24 come i more_vert standard, pallino di notifica in alto a destra)
  registerIcons(): void {
    this.matIconRegistry.addSvgIcon(
      'more-vert-notify',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/more-vert-notify.svg')
    );
  }
}
